// extracted by mini-css-extract-plugin
module.exports = {"swp":"swp___3LRx1","swrapper":"swrapper___uPV-2","discount":"discount___1E9i-","swrapper-normal":"swrapper-normal___1Mt4m","swrapper-active":"swrapper-active___39JrZ"};